// import { Outlet } from "react-router-dom";

// export function TeacherLayout() {
//   return (
//     <div>
//       <Outlet />
//     </div>
//   );
// }
import { AppShell } from "./AppShell";

export function TeacherLayout() {
  return <AppShell />;
}
